module.exports = __webpack_public_path__ + "img/google_play_icon.22e4a204.svg";